/// Grab values from location.hash by key
const FromHash = (key) => {
  // check if we passed in a string or an array
  const keys = typeof key === 'string' ? [key] : key;

  const hash = window.location.hash;

  const vals = {};

  if (hash.length) {
    // convert hash string to dict
    const hashProps = {};
    hash.replace('#','').split('&').forEach((p) => {
      const keyVal = p.split('=');
      if (keyVal.length === 2) {
        hashProps[keyVal[0]] = keyVal[1];
      }
    });

    // look up the keys we need to know
    keys.forEach((key) => {
      if (key in hashProps) {
        vals[key] = hashProps[key];
      }
    });
  }

  return vals;
};


export default FromHash;



// WEBPACK FOOTER //
// ./client/helpers/url-hash.js